import axios from 'axios'

// Get all products
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/product`)
  return data
}

// Create product
const create = async (name, desc, price, active, promotion, type, discount, expiration, pf, tv, nj, ba, njBotYan, pfBotYan, baBotYan) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/product`, {
    name,
    desc,
    price,
    active,
    promotion,
    type,
    discount,
    expiration,
    pf,
    tv,
    nj,
    ba,
    njBotYan,
    pfBotYan,
    baBotYan
  })
  return data
}

// Update product
const update = async (id, name, desc, price, active, promotion, type, discount, expiration, pf, tv, nj, ba, njBotYan, pfBotYan, baBotYan) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/product/${id}`, {
    name,
    desc,
    price,
    active,
    promotion,
    type,
    discount,
    expiration,
    pf,
    tv,
    nj,
    ba,
    njBotYan,
    pfBotYan,
    baBotYan
  })
  return data
}

// Remove product
const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/product/${id}`)
  return data
}

export {
  getAll,
  create,
  update,
  remove
}
